export enum ChatPrivacyEnum {
  PUBLIC = 'public',
  PRIVATE = 'private',
}
